import transformer from '../../services/devisCommandes/devisCommandeServerTableDataTransformer';
import HTTP from '../HTTP';
import store from '../../store/store';

const COMMANDE_URL = 'commandes/';


export async function getCommandes(userId, data) {
  try {
    const isAffixe2 = store.getters['parametrage/affixe2'];
    const payload = isAffixe2 ? transformer(data) : data;
    const response = await HTTP.post(COMMANDE_URL + 'by/user/' + userId, payload);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getCommandesByClient(userId, data, cliNum) {
  const isAffixe2 = store.getters['parametrage/affixe2'];
  const payload = isAffixe2 ? transformer(data) : data;
  try {
    const response = await HTTP.post(COMMANDE_URL + 'by/user/' + userId + '?annonceurNum=' + cliNum, payload);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getCommandesPdf(num, code, socCode) {
  try {
    const response = await HTTP.get(COMMANDE_URL + num + '/action/pdf?code=' + code + '&socCode=' + socCode, { responseType: 'arraybuffer' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function other() {
  try {
    const response = await HTTP.get(COMMANDE_URL);
    return response;
  } catch (e) {
    throw e;
  }
}




// WEBPACK FOOTER //
// ./src/api/commandes/index.js